
import React, { useState, useEffect } from 'react';


/*
 * хук расчитывает временной периуд и
 * пердоставляет функции для расчёта следующего/превидущего периуда
 */
export const useTimePeriod = cityCode => {
    const [timePeriod, setTimePeriod] = useState(false);

    // вычисляем объект недели
    const calcWeek = timeStatr => {
        let week = [];
        let date = new Date(timeStatr);

        for (let i = 1; i <= 7; i++) {
            let name = date.toLocaleDateString('ru-Ru', { weekday: 'short' });
            let dateStr = date.toLocaleDateString('ru-Ru', { day: '2-digit', month: '2-digit', year: 'numeric' });

            week.push({ name: name, date: dateStr });

            date.setDate(date.getDate() + 1);
        }

        return week;
    }

    // ?<--------------------------------------------------------------------------------------------------------------->

    // если периуд даты не заполнен, то вычесляем периуд
    if (timePeriod === false) {

        let date = new Date();

        let timePeriodObj = {};

        // если сегодня понидельник
        if (date.getDay() === 1) {

            timePeriodObj.statr = date.toISOString();

            date.setDate(date.getDate() + 6);

            timePeriodObj.finish = date.toISOString();
        } else {
            date.setDate(date.getDate() - (date.getDay() - 1));

            timePeriodObj.statr = date.toISOString();

            date.setDate(date.getDate() + 6);

            timePeriodObj.finish = date.toISOString();
        }

        timePeriodObj.week = calcWeek(timePeriodObj.statr);

        setTimePeriod(timePeriodObj);
    }

    // ?<--------------------------------------------------------------------------------------------------------------->

    // расчёт следующего временного периуда
    const nextTimePeriod = event => {
        let timePeriodObj = {};
        let date = new Date(timePeriod.statr);

        date.setDate(date.getDate() + 7);

        timePeriodObj.statr = date.toISOString();

        date.setDate(date.getDate() + 6);

        timePeriodObj.finish = date.toISOString();

        timePeriodObj.week = calcWeek(timePeriodObj.statr);

        setTimePeriod(timePeriodObj);
    }

    // ?<--------------------------------------------------------------------------------------------------------------->

    // расчёт превидущего временного периуда
    const lastTimePeriod = event => {
        let timePeriodObj = {};
        let date = new Date(timePeriod.statr);

        date.setDate(date.getDate() - 7);

        timePeriodObj.statr = date.toISOString();

        date.setDate(date.getDate() + 6);

        timePeriodObj.finish = date.toISOString();

        timePeriodObj.week = calcWeek(timePeriodObj.statr);

        setTimePeriod(timePeriodObj);
    }

    return [timePeriod, nextTimePeriod, lastTimePeriod];
}